import React, { useEffect, useMemo } from 'react';

import Alert from '@material-ui/lab/Alert';
import _ from 'lodash';
import moment from 'moment';
import { useDispatch } from 'react-redux';

import { useGrowthStagesConfig } from '../../../_store/selectors/configSelectors';
import { useGlobalSeasonSelectors } from '../../../_store/slices/gff/seasons/globalSeasonSlice';
import {
  getSeasonFeedbackStatisticsActions,
  useGetSeasonFeedbackStatisticsSelectors
} from '../../../_store/slices/statistics/getSeasonFeedbackStatisticsSlice';
import CommonDataGrid from '../../../Components/DataGrid/CommonDataGrid';
import LoadingIndicator from '../../../Components/LoadingIndicator';
import {
  ContentBody,
  ContentContainer,
  ContentHeader
} from '../../../Layout/Content';

const columns = [
  {
    field: 'growerName',
    headerName: 'Grower',
    width: 200,
    editable: false
  },
  {
    field: 'farmName',
    headerName: 'Farm',
    width: 200,
    editable: false
  },
  {
    field: 'fieldName',
    headerName: 'Field',
    width: 200,
    editable: false
  },
  {
    field: 'stageName',
    headerName: 'Growth Stage',
    width: 200,
    editable: false
  },
  {
    field: 'date',
    headerName: 'Stage Date',
    width: 150,
    editable: false,
    align: 'right',
    headerAlign: 'right',
    valueFormatter: (params) => {
      return params.value ? moment(params.value).format('ll') : '';
    }
  },
  {
    field: 'userName',
    headerName: 'User',
    width: 200,
    editable: false
  },
  {
    field: 'dateCreated',
    headerName: 'Date Created',
    width: 200,
    editable: false,
    align: 'right',
    headerAlign: 'right',
    valueFormatter: (params) => {
      return params.value ? moment(params.value).format('lll') : '';
    }
  },
  {
    field: 'dateModified',
    headerName: 'Date Modified',
    width: 200,
    editable: false,
    align: 'right',
    headerAlign: 'right',
    valueFormatter: (params) => {
      return params.value ? moment(params.value).format('lll') : '';
    }
  }
];

const SeasonFeedbackStatistics = () => {
  const dispatch = useDispatch();

  const { growthStagesConfig } = useGrowthStagesConfig();

  const { selectedSeason: seasonYear } = useGlobalSeasonSelectors();

  const { inProgress, errorMessage, response } =
    useGetSeasonFeedbackStatisticsSelectors(seasonYear);

  const rows = useMemo(
    () =>
      _.map(response, (item) => ({
        ...item,
        stageName: _.get(growthStagesConfig, [_.get(item, 'stage'), 'name']),
        userName: _.get(item, 'user.userName')
      })),
    [growthStagesConfig, response]
  );

  useEffect(() => {
    dispatch(getSeasonFeedbackStatisticsActions.submit({ seasonYear }));
  }, [dispatch, seasonYear]);

  return (
    <ContentContainer>
      <ContentHeader>
        <span>{`Season ${seasonYear} Growth Feedback`}</span>
      </ContentHeader>
      <ContentBody>
        {inProgress && <LoadingIndicator />}
        {!inProgress && errorMessage && (
          <Alert severity="error">{errorMessage}</Alert>
        )}
        {!inProgress && !errorMessage && (
          <CommonDataGrid rows={rows} columns={columns} />
        )}
      </ContentBody>
    </ContentContainer>
  );
};

export default SeasonFeedbackStatistics;
